export default "__VITE_ASSET__b13e1bc0__"